<template>
  <div class="form">
    <div class="form__header">
      <h3>Удалить задание</h3>
    </div>

    <form @submit.prevent="removeHomework" class="form__body">
      <p class="form__field">
        <span>Выберите учеников</span>
        <v-select 
          label="name" 
          :options="students" 
          v-model="selectedStudents" 
          :reduce="option => option.id" 
          :multiple="true" 
          :disabled="removeAll || allDates"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select> 
      </p>
      <p class="form__checkbox">
        <input 
          type="checkbox" 
          id="remove-all" 
          v-model="removeAll"
          :disabled="allDates"
        >
        <label for="remove-all">Все ученики</label>
      </p>
      <p class="form__checkbox">
        <input type="checkbox" id="all-dates" v-model="allDates">
        <label for="all-dates">Удалить всё</label>
      </p>

      <button 
        class="uk-button uk-button-primary submit" 
        :disabled="!selectedStudents.length && !removeAll && !allDates"
        type="submit"
      >
        Удалить
      </button>
    </form>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import { mapActions } from 'vuex';
export default {
  props: ['data'],
  inject: ['http'],
  data() {
    return {
      selectedStudents: [],
      removeAll: false,
      allDates: false
    }
  },
  computed: {
    students() {
      return this.data.map(item => item.student)
    },
    allStudentIds() {
      return this.data.map(item => item.student_id)
    },
    homeworkId() {
      return this.data[0].homework_id
    },
    date() {
      return this.data[0].date
    }
  },
  methods: {
    ...mapActions({
      getHomework: 'teacher/getHomework'
    }),
    removeHomework() {
      let data
      let path = this.allDates ? 'onRemoveHomework' : 'onDetachUserHomework'
      if (!this.allDates) {
        data = {
          homework_id: this.homeworkId,
          id: this.removeAll ? this.allStudentIds : this.selectedStudents,
          date: this.date
        }
      } else {
        data = {id: this.homeworkId}
      }
      this.http.post(path, data).then(() => {
        this.getHomework(this.$route.params.id)
        this.$emit('close-popup')
        swal('Задание удалено', '', 'success')
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))     
    }
  },
  components: { vSelect },
  watch: {
    removeAll() {
      if (this.removeAll) {
        this.selectedStudents = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 40px;
}

.form__body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>